"use client";
import React, { useState } from "react";
import { PricingSection } from "./PricingSection";

export const PricingToggle: React.FC = () => {
  const [billingPeriod, setBillingPeriod] = useState<"monthly" | "annual">("monthly");

  return (
    <>
      {/* Billing period toggle */}
      <section className="px-4 sm:px-6 pb-8 mx-auto max-w-[1200px] text-center">
        <div className="relative inline-grid grid-cols-2 gap-1 p-1 rounded-full dark:border dark:border-white/10 border border-blue-300 dark:bg-white/5 bg-blue-50">
          <div
            aria-hidden="true"
            className={`absolute top-1 bottom-1 left-1 w-[calc(50%-0.25rem)] rounded-full dark:bg-white bg-blue-600 shadow transition-transform duration-300 ease-out ${
              billingPeriod === "annual" ? "translate-x-full" : "translate-x-0"
            }`}
          />
          <button
            onClick={() => setBillingPeriod("monthly")}
            className={`relative z-10 w-[140px] sm:w-[150px] px-3 py-2 text-[13px] font-semibold rounded-full transition-colors duration-300 flex items-center justify-center ${
              billingPeriod === "monthly"
                ? "dark:text-[#020D30] text-white"
                : "dark:text-slate-400 dark:hover:text-white text-gray-500 hover:text-gray-900"
            }`}
          >
            Monthly
          </button>
          <button
            onClick={() => setBillingPeriod("annual")}
            className={`relative z-10 w-[140px] sm:w-[150px] px-3 py-2 text-[13px] font-semibold rounded-full transition-colors duration-300 flex items-center justify-center gap-1.5 ${
              billingPeriod === "annual"
                ? "dark:text-[#020D30] text-white"
                : "dark:text-slate-400 dark:hover:text-white text-gray-500 hover:text-gray-900"
            }`}
          >
            Annual
            <span
              className="text-[10px] font-bold px-1.5 py-0.5 rounded-full whitespace-nowrap bg-emerald-500 text-white shadow-sm"
            >
              SAVE 17%
            </span>
          </button>
        </div>

        {billingPeriod === "annual" && (
          <p className="mt-4 text-sm dark:text-slate-400 text-gray-500">
            Annual plans are billed in full upfront.{" "}
            <span className="dark:text-white text-gray-900 font-semibold">Save up to $69.98/year</span>{" "}
            vs monthly billing.
          </p>
        )}
      </section>

      <PricingSection billingPeriod={billingPeriod} />
    </>
  );
};
